/**
 * @fileoverview This file manages a collection of tools, registering them and providing functions to access and execute them. It also handles processing multiple tool calls.
 */

import { InputTool, ResponseToolCall, ToolDefinition } from '@iterator/shared-node/ai/llm_types'
import { error } from '@iterator/shared-node/util/logging'
import { generateCodeTool } from './generate_code_tool'
import { makeDirectoryTool } from './make_directory'
import { moveFileTool } from './move_file'
import { finishAndExitTool } from './finish_and_exit'
import { getUserInputTool } from './get_user_input_tool'
import { askTool } from './ask_tool'

const tools: Record<string, ToolDefinition> = {}

export function registerTool(toolDef: ToolDefinition) {
  tools[toolDef.name] = toolDef
}

registerTool(generateCodeTool)
registerTool(makeDirectoryTool)
registerTool(moveFileTool)
registerTool(finishAndExitTool)
registerTool(getUserInputTool)
registerTool(askTool)

export function allTools(): ToolDefinition[] {
  return Object.values(tools)
}

export function allInputTools(): InputTool[] {
  return allTools().map((tool) => ({
    name: tool.function.name,
    description: tool.function.description!,
    parameters: tool.function.parameters!,
  }))
}

export async function doCall(call: ResponseToolCall): Promise<string> {
  const { name, args } = call
  const tool = tools[name]
  if (!tool) {
    throw new Error(`Tool ${name} not found`)
  }
  return tool.execute(JSON.parse(args as string))
}

export async function doToolCalls(toolCalls: ResponseToolCall[]): Promise<string[]> {
  if (toolCalls.length === 0) {
    error('No tool calls found in response')
    return []
  }

  return Promise.all(toolCalls.map((toolCall) => doCall(toolCall)))
}
